import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlertIcon, WalletIcon, CompassIcon } from 'lucide-react';
export function ProblemsSection() {
  const problems = [{
    icon: <ShieldAlertIcon className="w-8 h-8 text-brand-accent" data-id="element-194" />,
    image: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=600&q=80&auto=format&fit=crop',
    imageAlt: 'Muncitor nesigur pe șantier',
    title: 'NESIGURANȚĂ',
    subtitle: 'LIPSĂ ÎNCREDERE · FRICĂ · BLOCAJ',
    text: 'Simți că nu ești destul de bun pentru meseria asta? Că alții știu mai mult și tu nu ai de unde să înveți? Vrei să faci un pas, dar frica de eșec te ține pe loc. Te întrebi dacă vei reuși vreodată să te simți sigur pe tine la un loc de muncă.'
  }, {
    icon: <WalletIcon className="w-8 h-8 text-brand-accent" data-id="element-195" />,
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=600&q=80&auto=format&fit=crop',
    imageAlt: 'Țevi industriale — pipefitting',
    title: 'VENITURI',
    subtitle: 'SALARIU MIC · INSTABILITATE · LIPSURI',
    text: 'Lucrezi mult, dar câștigi puțin. Sau nu ai un job deloc și nu știi de unde să mai scoți bani luna asta. Ai vrea un venit stabil, pe măsura efortului tău. Dar fără cunoștințele potrivite, rămâi mereu în aceeași situație. Și acasă se simt consecințele.'
  }, {
    icon: <CompassIcon className="w-8 h-8 text-brand-accent" data-id="element-196" />,
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80&auto=format&fit=crop',
    imageAlt: 'Șantier de construcții',
    title: 'DIRECȚIE',
    subtitle: 'CONFUZIE · SINGURĂTATE · FĂRĂ GHIDARE',
    text: 'Ai încercat să înveți pe cont propriu, după ureche. Poate ai făcut și niște cursuri, dar simți că tot nu stăpânești meseria. Nu ai pe nimeni care să te ghideze pas cu pas și să îți arate cum se face treaba cu adevărat, pe șantier.'
  }];
  return <section className="py-20 md:py-28 lg:py-32 bg-brand-dark" data-id="element-197">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 md:mb-20" data-id="element-199">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-brand-white uppercase tracking-industrial max-w-3xl mx-auto" data-id="element-200">
            Te regăsești în cel puțin una din aceste situații?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-201">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-grey border border-brand-border rounded-lg overflow-hidden hover:border-brand-accent transition-colors duration-300 group" data-id="element-202">
              {/* Card image */}
              <div className="relative h-48 overflow-hidden" data-id="element-203">
                <img src={problem.image} alt={problem.imageAlt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-204" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-grey via-brand-grey/40 to-transparent" data-id="element-205" />
                <div className="absolute top-4 left-4 w-12 h-12 bg-brand-black/80 backdrop-blur-sm rounded-lg border border-brand-border flex items-center justify-center group-hover:border-brand-accent/50 transition-colors" data-id="element-206">
                  {problem.icon}
                </div>
              </div>

              <div className="p-8 pt-4" data-id="element-207">
                <h3 className="font-heading font-bold text-2xl text-brand-white uppercase tracking-industrial mb-2" data-id="element-208">
                  {problem.title}
                </h3>

                <h4 className="font-sub font-medium italic text-brand-accent text-sm tracking-widest mb-6" data-id="element-209">
                  {problem.subtitle}
                </h4>

                <p className="font-body text-brand-muted leading-relaxed" data-id="element-210">
                  {problem.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}